export const clearTimeoutIfNeeded = (timeoutId) => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
};
